import { render, staticRenderFns } from "./rewardCallbackEdit.vue?vue&type=template&id=1a97cf59&scoped=true&"
import script from "./rewardCallbackEdit.vue?vue&type=script&lang=js&"
export * from "./rewardCallbackEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a97cf59",
  null
  
)

export default component.exports